import ObservableRaceFinisher from '@classic/Betting-v2/Model/Observables/ObservableRaceFinisher'
import ObservableResultsPage from '@classic/Betting-v2/Model/Observables/ObservableResultsPage'
import BaseFinisherViewModel from '../BaseFinisherViewModel'
import { MatchedFieldSummaryResults } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummaryResults'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import { JockeyName } from '@core/Areas/RaceCard/Components/JockeyName'

export interface Params {
  raceInformation: ObservableResultsPage
  finisher: ObservableRaceFinisher
  showField: boolean
}

export class RaceFinisherViewModel extends BaseFinisherViewModel {
  public MatchedFieldSummaryResults: typeof MatchedFieldSummaryResults
  public MatchedFieldSummary: typeof MatchedFieldSummary
  public JockeyName: typeof JockeyName

  constructor(params: Params) {
    super(params)
    this.MatchedFieldSummaryResults = MatchedFieldSummaryResults
    this.MatchedFieldSummary = MatchedFieldSummary
    this.JockeyName = JockeyName
  }
}
